export default function Divider({ color }) {
    let className = 'divider'
    if (color) {
        className += ` divider-${color}`
    }
    return <div className={className}> </div>
}
